import {} from "@sinclair/typebox";
import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
import { createTeamRequestSchema, } from "../../teams/teamsTypes.js";
export const createTeam = async ({ name, description, created_by, }) => {
    console.log("Calling createFreemium with:", {
        name,
        description,
        created_by,
    });
    try {
        const response = await api.post(`teams`, {
            json: { name, description, created_by },
        });
        return await response.json();
    }
    catch (error) {
        console.error("Error creating team:", error);
        throw error;
    }
};
export const useCreateTeam = ({ mutationConfig, } = {}) => {
    return useMutation({
        mutationFn: createTeam,
        ...mutationConfig,
    });
};
//# sourceMappingURL=createTeam.js.map